import { useRef, useState } from "react";
import { createApiCall } from "../api/api-service";
import { Box, Button } from "@mui/material";

export default function UploadEcom() {
  const fileInputRef = useRef();
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState([]);
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    setStatus("");
  };
  const handleClear = () => {
    setFiles([]);
    setStatus("");
    if (fileInputRef.current) fileInputRef.current.value = null;
  };
  const handleUpload = async () =>{
    if(files.length === 0 ){
        setStatus("Please Select FIle")
        return
    }
    const formRequest = new FormData();
    files.forEach((file, index) => {
      formRequest.append("files", file); // Use 'files' as Django expects a list
    });

    const response = await createApiCall("POST","inventory/upload_ecom_data",formRequest,true, {
          "Content-Type": "multipart/form-data",
        });

    if (response?.response === "000") {
        setStatus(response?.data);
        setFiles([])
      } else {
        setStatus("Upload Failed");
      }
  }
  return (
    <>
      <Box sx={{ maxWidth: "500px", mx: "auto", mt: 4, textAlign: "center" }}>
        <input
          type="file"
          ref={fileInputRef}
          multiple
          onChange={handleFileChange}
          style={{ marginBottom: "16px" }}
        />
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={files.length === 0}
        >
          Upload
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClear}
          disabled={status.length === 0}
        >
          Clear
        </Button>
        <p>{status}</p>
      </Box>
    </>
  );
}
